module.exports = __webpack_public_path__ + "img/(10).fab7c923.jpg";